import React from 'react';

import classes from '../installPics.css';

import GM1 from '../../../../../../../assets/GM4.jpg';

const GM1IMG = () => (
    <div className={classes.installImages}>
        <img alt="A Ground mount Solar Array" src={GM1} className={classes.installImg} />
    </div>
);


export default GM1IMG;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/InstallImages/GroundMountImages/GM1.js